import SnackbarProvider from './snackbar-provider'

export default SnackbarProvider
